import { render, staticRenderFns } from "./MyCourseAssessment.vue?vue&type=template&id=2a01eeac"
import script from "./MyCourseAssessment.vue?vue&type=script&lang=ts"
export * from "./MyCourseAssessment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports